import { useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

const topBufferOffsetPx = 72
const scrollTimeoutMs = 100

/**
 * Reads the current hash from the URL and scrolls to focus it in the user's view.
 * If the hash is unset, scrolls to the top
 */
const CurrentHashElementScroller = ({ location }: RouteComponentProps) => {
  useEffect(() => {
    const element = document.getElementById(location.hash)

    const scrollTimeout = setTimeout(() => {
      window.scrollTo({
        behavior: element ? 'smooth' : 'auto',
        top: element ? element.offsetTop - topBufferOffsetPx : 0,
      })
    }, scrollTimeoutMs)

    return () => {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout)
      }
    }
  }, [location.hash])

  return null
}

export default withRouter(CurrentHashElementScroller)
